/// <amd-module name="VSSUI/PillGroup" />
export { PillGroup } from "./Components/PillGroup/PillGroup";
export { IPillGroupProps, PillGroupOverflow } from "./Components/PillGroup/PillGroup.Props";
